import { SnackbarProvider, useSnackbar } from 'notistack'
import { useMemo, type ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

export const useNotification = () => {
  const { enqueueSnackbar } = useSnackbar()
  const { t } = useTranslation()
  return useMemo(
    () => ({
      showSuccess: (message?: string) =>
        enqueueSnackbar(message || t('common.messages.success'), { variant: 'success' }),
      showError: (message?: string) => enqueueSnackbar(message || t('common.messages.error'), { variant: 'error' }),
    }),
    [enqueueSnackbar, t],
  )
}

interface Props {
  children: ReactNode
}

const NotificationProvider = ({ children }: Props) => {
  return <SnackbarProvider>{children}</SnackbarProvider>
}

export default NotificationProvider
